module.exports = __webpack_public_path__ + "img/data-icon-1.b88e86db.png";